import React from 'react';

import type { IChartEventSetting } from '@/pages/dashboard/filterPageComponents/overview/KpiEventFilter';

export interface IKpiOverviewEventInjectValue {
  eventData: unknown;
  loading: boolean;
  /**
   * 与 KpiEventFilter / useKpiEventSetting 同源：图表读取其中轴/气泡、bubble、
   * 「显示 A/B 实验详情」以与筛选一致；本卡事件设置弹窗可额外打开平铺（与筛选 OR）。
   */
  kpiSharedEventSetting?: {
    chartEventSetting: IChartEventSetting;
    changeEventSetting: (setting: IChartEventSetting) => void;
  };
}

const defaultInjectValue: IKpiOverviewEventInjectValue = {
  eventData: undefined,
  loading: true,
};
export const KpiOverviewEventInjectContext =
  React.createContext<IKpiOverviewEventInjectValue>(defaultInjectValue);

KpiOverviewEventInjectContext.displayName = 'KpiOverviewEventInjectContext';
